export const ChooseModelIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C12.4142 2 12.75 2.33579 12.75 2.75C12.75 5.87025 13.4387 7.94571 14.7465 9.25352C16.0543 10.5613 18.1297 11.25 21.25 11.25C21.6642 11.25 22 11.5858 22 12C22 12.4142 21.6642 12.75 21.25 12.75C18.1297 12.75 16.0543 13.4387 14.7465 14.7465C13.4387 16.0543 12.75 18.1297 12.75 21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25C11.25 18.1297 10.5613 16.0543 9.25352 14.7465C7.94571 13.4387 5.87025 12.75 2.75 12.75C2.33579 12.75 2 12.4142 2 12C2 11.5858 2.33579 11.25 2.75 11.25C5.87025 11.25 7.94571 10.5613 9.25352 9.25352C10.5613 7.94571 11.25 5.87025 11.25 2.75C11.25 2.33579 11.5858 2 12 2ZM12 7.6357C11.6079 8.68025 11.053 9.57535 10.3142 10.3142C9.57535 11.053 8.68025 11.6079 7.6357 12C8.68025 12.3921 9.57535 12.947 10.3142 13.6858C11.053 14.4247 11.6079 15.3197 12 16.3643C12.3921 15.3197 12.947 14.4247 13.6858 13.6858C14.4247 12.947 15.3197 12.3921 16.3643 12C15.3197 11.6079 14.4247 11.053 13.6858 10.3142C12.947 9.57535 12.3921 8.68025 12 7.6357Z"
        fill="#737373"
      />
    </svg>
  );
};
